<template>
  <div>
    <hs-breadcrumb :breadcrumb="breadcrumb"></hs-breadcrumb>
    <Card :bordered="false" :style="{marginBottom:'10px'}">
      <div class="hs-screen-row">
        <Input v-model="params.realName" placeholder="客户姓名" clearable style="width: 200px"/>
      </div>
      <div class="hs-screen-row">
        <DatePicker @on-change="changeDate" v-model="dateInit" type="daterange" :editable="false"
                    separator=" ~ " split-panels transfer
                    placeholder="创建时间" style="width: 200px"></DatePicker>
      </div>
      <div class="hs-screen-row">
        <Button type="primary" @click="findList">查询</Button>
      </div>
      <div class="hs-screen-row">
        <Button @click="resetScreen">重置</Button>
      </div>
    </Card>

    <Card :bordered="false" :style="{marginBottom:'10px'}">
      <!--标题-->
      <div slot="title">
        <div class="hs-screen-box">
          <div>申请列表</div>
          <div>
            <ButtonGroup>
              <Button @click="findList">
                <Icon type="md-refresh" size="15"/>
              </Button>
            </ButtonGroup>
          </div>
        </div>
      </div>
      <!--表格数据-->
      <Table :columns="columns" :data="data" size="small" :stripe="true" :loading="isTableLoading">

        <template slot-scope="{ row, index }" slot="state">
          <Tag color="green" v-if="row.state === 0" size="default">待审核</Tag>
          <Tag color="blue" v-if="row.state === 1" size="default">通过</Tag>
          <Tag color="volcano" v-if="row.state === 2" size="default">拒绝</Tag>
        </template>

        <template slot-scope="{ row }" slot="action">
          <Button type="success" size="small" style="margin-right: 5px" @click="showStarOpe(1, row)">查看
          </Button>
          <template v-if="row.state === 0">
            <Button type="success" size="small" style="margin-right: 5px" @click="examine(row, true)">通过
            </Button>
            <Button type="error" size="small" style="margin-right: 5px" @click="examine(row, false)">拒绝
            </Button>
          </template>
        </template>
      </Table>
      <!--分页-->
      <div class="hs-page">
        <Page :total="total" show-sizer show-total transfer @on-change="changePage"
              @on-page-size-change="changePageSize"/>
      </div>
    </Card>

    <star-ope ref="starOpe"></star-ope>

    <Modal v-model="isModel" :title="modelTitle" @on-ok="ok" @on-cancel="cancel">
      <Input v-model="reason" type="textarea" :rows="3" placeholder="请输入拒绝理由..."></Input>
    </Modal>
  </div>
</template>

<script>
import hsBreadcrumb from '@/components/hs-breadcrumb';
import starOpe from './components/star-ope.vue';

export default {
  data() {
    return {
      admin: JSON.parse(sessionStorage.getItem('J-ADMIN')),
      total: 0,
      dateInit: '',
      isTableLoading: false,
      // 参数
      params: {
        page: 1,
        rows: 10,
        username: '',
        realName: '',
        level: '',
        startTime: '',
        endTime: '',
        isDisable: '',
      },
      // 表格列
      columns: [
        {
          type: 'index',
          width: 60,
          align: 'center'
        },
        {
          title: '用户昵称',
          minWidth: 180,
          key: 'nickName'
        },
        {
          title: '客户姓名',
          minWidth: 100,
          key: 'realName'
        },
        {
          title: '联系方式',
          minWidth: 100,
          key: 'mobile'
        },
        {
          title: '地址',
          minWidth: 250,
          key: 'address'
        },
        {
          title: '详细地址',
          minWidth: 250,
          key: 'locationAddress'
        },
        {
          title: '申请状态',
          slot: 'state',
          align: 'center',
          width: 120
        },
        {
          title: '申请时间',
          key: 'createTime',
          width: 150,
          align: 'center',
        },
        {
          title: '审核人员',
          key: 'operatorName',
          width: 100,
          align: 'center',
        },
        {
          title: '审核时间',
          key: 'updateTime',
          width: 150,
          align: 'center',
        },
        {
          title: '操作',
          slot: 'action',
          width: 220,
          align: 'center'
        }
      ],
      // 表格数据
      data: [],
      // 面包屑
      breadcrumb: [
        {name: '首页', url: '', icon: 'ios-home-outline', size: 18},
        {name: '星标用户', url: '', icon: '', size: 0},
        {name: '用户列表', url: '', icon: '', size: 0}
      ],
      isModel: false,
      modelTitle: '',
      reason: '',
      applyId: '',
      tenantList: []
    }
  },
  created() {
    // 用户-列表查询
    this.findList();
  },
  methods: {
    // 用户-列表查询
    findList() {
      this.isTableLoading = true;
      this.axios.post('/userStarApply/findList', this.params).then(res => {
        console.log(res);
        this.isTableLoading = false;
        if (res.status == 200) {
          this.total = res.data.total;
          this.data = res.data.rows;
        }
        if (res.status == 500) {
          this.$Notice.error({
            title: '服务器内部错误',
            desc: '查询星标用户申请列表接口报错',
            duration: 0
          });
        }
      })
    },
    // 审核
    examine(row, flag) {
      this.applyId = row.applyId
      if (!flag) {
        this.isModel = true
        this.modelTitle = `是否拒绝用户${row.nickName}的申请？`
      } else {
        this.$Modal.confirm({
          title: `是否${flag ? '通过' : '拒绝'}用户${row.nickName}的申请？`,
          onOk: () => {
            this.examineApply(flag);
          },
          onCancel: () => {
            this.$Message.info('您点击了取消.');
          }
        });
      }
    },
    // 拒绝
    ok () {
      this.examineApply(false);
    },
    cancel () {
      this.reason = ''
    },
    // 通过或拒绝申请
    examineApply(flag) {
      this.$Spin.show();
      this.axios.post('/userStarApply/examine', {
        applyId: this.applyId,
        state: flag ? 1 : 2,
        reason: this.reason
      }).then(res => {
        console.log(res);
        this.reason = ''
        setTimeout(() => {
          this.$Spin.hide();
        }, 300);
        if (res.status == 200) {
          this.$Message.success('操作成功.');
          this.findList();
        }
        if (res.status == 201) {
          // this.$Message.error(res.msg);
          this.$Notice.error({
            title: '审核失败',
            desc: res.msg
          });
        }
        if (res.status == 500) {
          this.$Notice.error({
            title: '服务器内部错误',
            desc: '审核星标用户申请接口报错',
            duration: 0
          });
        }
      })
    },
    // 日期条件赋值
    changeDate(e) {
      this.params.startTime = e[0];
      this.params.endTime = e[1];
    },
    // 重置筛选条件
    resetScreen() {
      this.params.realName = '';
      this.params.isDisable = '';
      this.params.startTime = '';
      this.params.endTime = '';
      this.dateInit = '';
    },
    // 改变页数
    changePage(e) {
      this.params.page = e;
      this.findList();
    },
    // 改变页容量
    changePageSize(e) {
      this.params.rows = e;
      this.findList();
    },
    // 显示操作模态框
    // 显示操作模态框
    showStarOpe(type, row) {
      this.$refs.starOpe.show(type, row);
    },
  },
  components: {
    hsBreadcrumb,
    starOpe
  }
}
</script>

<style scoped>

</style>